module.exports = __webpack_public_path__ + "static/media/0011.d4bc4fc6.jpg";